/**
 * REGISTRO DE ALVOS DA TELA - a fonte unica dos campos que o Rimati aponta.
 *
 * Cada entrada e um campo/botao que uma pagina marca com `data-rimati-target`.
 * Indices viram `#` (o item 2 do carrinho e `pdv.item.#.quantidade`). Daqui saem:
 * - o tipo `ScreenTargetId`: `rimatiTarget(id)` na web so aceita ids registrados
 *   (id inexistente e erro de compilacao);
 * - `MARKED_TARGETS`/`HIGHLIGHT_MODULES` da web (quais alvos tem botao "Mostrar");
 * - a conferencia do servidor: todo alvo registrado precisa existir no catalogo
 *   de ajuda da mesma tela (teste em `screen-help.test.ts`).
 *
 * COMO ACRESCENTAR UM CAMPO: 1) registre aqui, com a tela (`module`, chave de
 * `SCREEN_MODULES`); 2) marque o elemento com `rimatiTarget(id)`; 3) acrescente
 * o alvo ao catalogo de ajuda da tela no servidor. Os testes cobram os tres.
 */
export const SCREEN_TARGET_REGISTRY = {
  'agenda.acompanhamento': { module: 'agenda.agenda' },
  'agenda.novo': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.busca': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.cliente': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.consultar-horarios': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.dia': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.horario': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.modalidade': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.profissional': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.salvar': { module: 'agenda.agenda' },
  'agenda.novo-agendamento.servico': { module: 'agenda.agenda' },
  'agenda.periodo.anterior': { module: 'agenda.agenda' },
  'agenda.periodo.atual': { module: 'agenda.agenda' },
  'agenda.periodo.proximo': { module: 'agenda.agenda' },
  'agenda.visao': { module: 'agenda.agenda' },
  'balcao.abrir-caixa.conta': { module: 'balcao.pdv' },
  'balcao.abrir-caixa.contado': { module: 'balcao.pdv' },
  'balcao.abrir-caixa.revisar': { module: 'balcao.pdv' },
  'balcao.abrir-caixa.terminal': { module: 'balcao.pdv' },
  'balcao.busca-produto': { module: 'balcao.pdv' },
  'balcao.busca-produto.buscar': { module: 'balcao.pdv' },
  'balcao.desconto': { module: 'balcao.pdv' },
  'balcao.encerrar-caixa.contado': { module: 'balcao.pdv' },
  'balcao.encerrar-caixa.revisar': { module: 'balcao.pdv' },
  'balcao.pagamento.conferido': { module: 'balcao.pdv' },
  'balcao.pagamento.dinheiro-entregue': { module: 'balcao.pdv' },
  'balcao.pagamento.forma': { module: 'balcao.pdv' },
  'balcao.revisar-venda': { module: 'balcao.pdv' },
  'caixa.abrir.conta-fisica': { module: 'caixa.sessoes' },
  'caixa.abrir.revisar': { module: 'caixa.sessoes' },
  'caixa.abrir.terminal': { module: 'caixa.sessoes' },
  'caixa.fechamento.motivo': { module: 'caixa.sessoes' },
  'caixa.fechamento.revisar': { module: 'caixa.sessoes' },
  'caixa.fechamento.valor-contado': { module: 'caixa.sessoes' },
  'caixa.movimento.motivo': { module: 'caixa.sessoes' },
  'caixa.movimento.reforcar': { module: 'caixa.sessoes' },
  'caixa.movimento.sangria': { module: 'caixa.sessoes' },
  'caixa.movimento.valor': { module: 'caixa.sessoes' },
  'caixa.relatorios.ate': { module: 'caixa.sessoes' },
  'caixa.relatorios.de': { module: 'caixa.sessoes' },
  'caixa.relatorios.secao': { module: 'caixa.sessoes' },
  'caixa.relatorios.tipo': { module: 'caixa.sessoes' },
  'caixa.relatorios.ver': { module: 'caixa.sessoes' },
  'caixa.sessoes.lista': { module: 'caixa.sessoes' },
  'clientes.busca': { module: 'crm.contatos' },
  'clientes.editar': { module: 'crm.contatos' },
  'clientes.novo': { module: 'crm.contatos' },
  'clientes.novo.confirmar': { module: 'crm.contatos' },
  'clientes.novo.email': { module: 'crm.contatos' },
  'clientes.novo.nome': { module: 'crm.contatos' },
  'clientes.novo.telefone': { module: 'crm.contatos' },
  'clientes.ordenar': { module: 'crm.contatos' },
  'clientes.unificar': { module: 'crm.contatos' },
  'estoque.aba.movimentar': { module: 'estoque.saldos' },
  'estoque.aba.pedidos-anteriores': { module: 'estoque.saldos' },
  'estoque.aba.perdas': { module: 'estoque.saldos' },
  'estoque.aba.reservas': { module: 'estoque.saldos' },
  'estoque.aba.saldos': { module: 'estoque.saldos' },
  'estoque.aba.saude': { module: 'estoque.saldos' },
  'estoque.aba.transferencias': { module: 'estoque.saldos' },
  'estoque.mov.buscar': { module: 'estoque.saldos' },
  'estoque.mov.local': { module: 'estoque.saldos' },
  'estoque.mov.motivo': { module: 'estoque.saldos' },
  'estoque.mov.operacao': { module: 'estoque.saldos' },
  'estoque.mov.produto': { module: 'estoque.saldos' },
  'estoque.mov.quantidade': { module: 'estoque.saldos' },
  'estoque.mov.revisar': { module: 'estoque.saldos' },
  'estoque.mov.variacao': { module: 'estoque.saldos' },
  'estoque.saldos.reposicao': { module: 'estoque.saldos' },
  'estoque.saldos.tabela': { module: 'estoque.saldos' },
  'pdv.busca-produto': { module: 'vendas.pdv' },
  'pdv.cliente.busca': { module: 'vendas.pdv' },
  'pdv.cliente.nome-sem-cadastro': { module: 'vendas.pdv' },
  'pdv.cliente.trocar': { module: 'vendas.pdv' },
  'pdv.cliente.usar': { module: 'vendas.pdv' },
  'pdv.comprovante.cancelar': { module: 'vendas.pdv' },
  'pdv.comprovante.cancelar.motivo': { module: 'vendas.pdv' },
  'pdv.comprovante.cancelar.revisar': { module: 'vendas.pdv' },
  'pdv.finalizar-venda': { module: 'vendas.pdv' },
  'pdv.historico.data-final': { module: 'vendas.pdv' },
  'pdv.historico.data-inicial': { module: 'vendas.pdv' },
  'pdv.historico.todo-periodo': { module: 'vendas.pdv' },
  'pdv.item.#.desconto': { module: 'vendas.pdv' },
  'pdv.item.#.desconto-percentual': { module: 'vendas.pdv' },
  'pdv.item.#.quantidade': { module: 'vendas.pdv' },
  'pdv.item.#.remover': { module: 'vendas.pdv' },
  'pdv.limpar-carrinho': { module: 'vendas.pdv' },
  'pdv.limpar-carrinho.confirmar': { module: 'vendas.pdv' },
  'pdv.local-estoque': { module: 'vendas.pdv' },
  'pdv.pagamento.#.cartao-metodo': { module: 'vendas.pdv' },
  'pdv.pagamento.#.dinheiro-entregue': { module: 'vendas.pdv' },
  'pdv.pagamento.#.forma': { module: 'vendas.pdv' },
  'pdv.pagamento.#.parcelas': { module: 'vendas.pdv' },
  'pdv.pagamento.#.valor': { module: 'vendas.pdv' },
  'pdv.pagamento.adicionar': { module: 'vendas.pdv' },
  'pdv.pagamento.detalhes-taxas': { module: 'vendas.pdv' },
  'pdv.revisar-venda': { module: 'vendas.pdv' },
  'pdv.tab.configuracoes': { module: 'vendas.pdv' },
  'pdv.tab.historico': { module: 'vendas.pdv' },
  'pdv.tab.nova-venda': { module: 'vendas.pdv' },
} as const satisfies Record<string, { module: string }>;

/** Chave do registro: `#` no lugar de qualquer indice. */
export type ScreenTargetPattern = keyof typeof SCREEN_TARGET_REGISTRY;

type ExpandIndex<S extends string> = S extends `${infer A}#${infer B}`
  ? `${A}${number}${ExpandIndex<B>}`
  : S;

/** Um id utilizavel numa pagina: o padrao com o indice numerico no lugar do `#`. */
export type ScreenTargetId = ExpandIndex<ScreenTargetPattern>;

/** `pdv.item.2.quantidade` -> `pdv.item.#.quantidade`. */
export function screenTargetPattern(id: string): string {
  return id.replace(/\.\d+(?=\.|$)/g, '.#');
}

export function isRegisteredScreenTarget(id: string): boolean {
  return Object.hasOwn(SCREEN_TARGET_REGISTRY, screenTargetPattern(id));
}

/** A tela (chave de `SCREEN_MODULES`) a que o alvo pertence, ou `null`. */
export function screenTargetModule(id: string): string | null {
  const entry = (SCREEN_TARGET_REGISTRY as Record<string, { module: string } | undefined>)[
    screenTargetPattern(id)
  ];
  return entry?.module ?? null;
}

/** As telas que tem ao menos um alvo registrado (o "Mostrar" so aparece nelas). */
export const SCREEN_TARGET_MODULES: ReadonlySet<string> = new Set(
  Object.values(SCREEN_TARGET_REGISTRY).map((entry) => entry.module),
);
